import { useState, MouseEvent } from 'react';
import Card from '@tempcover/bolt-ui/card';
import { ActionButton } from '../ActionButton/ActionButton';

export interface Person {
  name: string;
  jobTitle: string;
  image: string;
  info: string;
  profileLink: string;
}

const PersonCard = ({ name, jobTitle, image, info, profileLink }: Person) => {
  const [expandInfo, setExpandInfo] = useState<boolean>(false);
  const excerpt = info ? info.split('</p>')[0].replace('<p>', '').slice(0, 150) : '';

  const handleExpand = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setExpandInfo(true);
  };

  return (
    <Card className="flex flex-col items-center">
      <img src={image} className="mb-4 h-auto max-w-[100px] rounded-[50%]" alt="" role="presentation" />
      <h3>{name}</h3>
      <div className="text-lg">
        <strong>{jobTitle}</strong>
      </div>
      {expandInfo ? (
        <div className="mb-4 text-center" dangerouslySetInnerHTML={{ __html: info }} aria-hidden={true} />
      ) : (
        <div className="mb-4 text-center" aria-hidden={true}>
          <p>
            {excerpt}..
            <button onClick={handleExpand} className="hover:text-primary font-bold underline">
              more
            </button>
          </p>
        </div>
      )}
      <div className="sr-only" dangerouslySetInnerHTML={{ __html: info }} />
      <a
        href={profileLink}
        target="_blank"
        className="mt-auto mb-0"
        aria-label={`External link to ${name}'s Linkedin profile`}
      >
        <ActionButton variant="line">Profile</ActionButton>
      </a>
    </Card>
  );
};

export default PersonCard;
